import { render, staticRenderFns } from "./broadcast.vue?vue&type=template&id=5e5d42be&scoped=true"
import script from "./broadcast.vue?vue&type=script&lang=js"
export * from "./broadcast.vue?vue&type=script&lang=js"
import style0 from "./broadcast.vue?vue&type=style&index=0&id=5e5d42be&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5d42be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e5d42be')) {
      api.createRecord('5e5d42be', component.options)
    } else {
      api.reload('5e5d42be', component.options)
    }
    module.hot.accept("./broadcast.vue?vue&type=template&id=5e5d42be&scoped=true", function () {
      api.rerender('5e5d42be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/broadcast/broadcast.vue"
export default component.exports